import React, { useMemo, useState } from 'react'
import cn from 'classnames'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'
import List from '../List'
import s from './s.module.css'
import { lang } from './lang'
import { Transaction } from '~pages/CardsPage/Cards/Transactions/types'
import { useCards, useGetThreeDSChallengesData } from '~api'
import CardImage from '~pages/CardsPage/components/CardImage'
import { processChallenge } from '~utils/processChallenge'

interface Props {
    onRowClick: (tx: Transaction) => void
    initCardId?: string
}

function Content({ onRowClick, initCardId }: Props) {
    const { data: chs } = useGetThreeDSChallengesData()
    const { data: cards } = useCards()
    const [selectedCardId, setSelectedCardId] = useState<string | undefined>(initCardId)

    const challenges = chs?.challenges.map(processChallenge)

    const chCards = useMemo(() => {
        const uniqueChCards = new Set(challenges?.map(challenge => challenge?.card_id || []))
        return cards?.cards?.filter(card => uniqueChCards.has(card?.id)) || []
    }, [cards?.cards, challenges])

    const selectedChCard = chCards?.find(chCard => chCard?.id === selectedCardId) || chCards[0]
    const selectedChallenges = challenges?.filter(ch => ch?.card_id === selectedChCard?.id)

    return (
        <div className={s.wrap}>
            {chCards?.length > 0 && (
                <div className={s.tags}>
                    {chCards?.map(chCard => (
                        <div
                            className={cn(s.tag, selectedChCard?.id === chCard?.id && s.selected)}
                            key={chCard.id}
                            onClick={() => setSelectedCardId(chCard.id)}
                        >
                            <div className={s.cardImg}>
                                <CardImage designId={chCard?.card_design?.id} />
                            </div>
                            <span>·· {chCard?.masked_number || '****'}</span>
                        </div>
                    ))}
                </div>
            )}
            {!selectedChallenges?.length ? (
                <div className={s.emptyWrap}>
                    <FormattedHTMLMessage {...lang.empty} className={s.emptyText} />
                </div>
            ) : (
                <List onRowClick={onRowClick} data={selectedChallenges} />
            )}
        </div>
    )
}

export default Content
